export type Severity = 'error' | 'warn' | 'log' | 'info' | 'debug';
export const severities: Severity[] = ['error', 'warn', 'log', 'info', 'debug'];

export const getSeverities = (severity: Severity | 'all') => {
  severity = severity === 'all' ? 'error' : severity;
  const maxSeverityIndex = (severities as string[]).indexOf(severity);
  const neededSeverities = severities.slice(maxSeverityIndex);

  if (maxSeverityIndex === -1) {
    throw new Error(
      `Invalid Datadog severity provided! Received: ${severity}. Allowed: ${severities.join(
        ', ',
      )}`,
    );
  }

  return neededSeverities;
};
